import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";

const bulkEditWaitTime = async ({ testCaseId, data, wait, waittime }) => {
  const userDetailString = localStorage.getItem("userDetail");
  if (!userDetailString) throw new Error("No user details found in localStorage");

  const user = JSON.parse(userDetailString);

  const response = await axios.post(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=updateBulkWaitTime&companyid=${user.companyid}&testCaseId=${testCaseId}&waittime=${waittime}&wait=${wait}`,
    data,
  );

  return response.data;
};

const useBulkEditWaitTime = () => {
  return useMutation({
    mutationFn: (variables) => bulkEditWaitTime(variables),
  });
};

export default useBulkEditWaitTime;
